export default "__VITE_ASSET__BAMknhEz__"